import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SettingsLayout } from "@NP-Webber/crm-kit/dist/next/index.js";
import { ScreenHeader } from "../../next/page/ScreenHeader";
import { useShell } from "../../next/shell/ShellContext";
import { HUB_SECTIONS } from "../../next/settings/settingsSections";

/** /settings — every organization setting in one searchable hub (?section=<key> opens a section). */
export function SettingsPage() {
  const navigate = useNavigate();
  const { can, allowed } = useShell();
  const [params, setParams] = useSearchParams();
  const value = params.get("section") || "field-policies";

  const sections = useMemo(
    () =>
      HUB_SECTIONS.filter((s) => (!s.nav || can(s.nav)) && (!s.perm || s.perm.some(allowed))).map((s) => ({
        key: s.key,
        group: s.group,
        icon: s.icon,
        title: s.title,
        description: s.description,
        render: s.render,
        onOpen: s.path ? () => navigate(s.path as string) : undefined,
      })),
    [can, allowed, navigate],
  );

  return (
    <section className="page-section" aria-label="הגדרות והרשאות">
      <ScreenHeader sub="כל ההגדרות של הארגון במקום אחד · Ctrl+, פותח את ההגדרות של כל מסך" />
      <SettingsLayout
        sections={sections}
        value={value}
        onChange={(key) => {
          const next = new URLSearchParams(params);
          next.set("section", key);
          setParams(next, { replace: true });
        }}
      />
    </section>
  );
}
